import {Badge} from "@mantine/core";
import { CustomerStatus } from '../types';

export const CustomerStatusBadge = ({status}: { status: CustomerStatus }) => {
    let color = '';
    
    switch (status) {
        case 'ACTIVE':
        case 'ACTIVE_GRACE':
            color = 'green';
            break;
        case 'TRIAL':
            color = 'blue';
            break;
        case 'PROSPECT':
            color = 'cyan';
            break;
        case 'PAUSED':
        case 'SUSPENDED':
            color = 'yellow';
            break;
        case 'PAST_DUE':
            color = 'orange';
            break;
        case 'CANCELLED':
        case 'TRIAL_EXPIRED':
        case 'DOWNGRADED':
        case 'BLOCKED':
            color = 'red';
            break;
        case 'INACTIVE':
        case 'ARCHIVED':
            color = 'gray';
            break;
        default:
            color = 'gray';
    }
    
    return <Badge color={color}>{status}</Badge>;
};